"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerState = exports.GloballyAllowedSidebar = void 0;
/* eslint-disable no-unused-vars */
var GloballyAllowedSidebar;
(function (GloballyAllowedSidebar) {
    // previews are read-only views of pages CASSI serves
    GloballyAllowedSidebar["EMAIL_PREVIEW"] = "email";
    GloballyAllowedSidebar["INVOICE_PREVIEW"] = "invoice";
    GloballyAllowedSidebar["REFUND_PREVIEW"] = "refund";
    GloballyAllowedSidebar["SUPPORT_ISSUE_PREVIEW"] = "support";
    // mutatable actions that users will can perform from a sidebar
    GloballyAllowedSidebar["BILLING_SERVICE_CREDIT_FORM"] = "create-service-credit";
    GloballyAllowedSidebar["BILLING_PROCESS_REFUND_FORM"] = "process-refund";
    GloballyAllowedSidebar["BILLING_PROCESS_REFUND_FORM_CCP"] = "process-refund-ccp";
    GloballyAllowedSidebar["ADD_NEW_CLOUD_SITE"] = "add-new-cloud-site";
    GloballyAllowedSidebar["INVOICE_PREVIEW_V2"] = "invoice-preview-v2";
    GloballyAllowedSidebar["UNASSIGN_CLOUD_SITE_PANE"] = "un-assign-reserved-site";
    GloballyAllowedSidebar["CLOUD_SITE_AUDIT_LOG_PREVIEW"] = "cloud-site-audit-log-preview";
    GloballyAllowedSidebar["SELF_SERVE_BAC_INVOICE_LINK"] = "self-serve-bac-invoice-link";
    GloballyAllowedSidebar["REFUND_REINVOICE_PANE"] = "refund-reinvoice-pane";
})(GloballyAllowedSidebar = exports.GloballyAllowedSidebar || (exports.GloballyAllowedSidebar = {}));
var TrackerState;
(function (TrackerState) {
    TrackerState["VISITED"] = "visited";
    TrackerState["CURRENT"] = "current";
    TrackerState["UNVISITED"] = "unvisited";
})(TrackerState = exports.TrackerState || (exports.TrackerState = {}));
